import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { TELEMETRY_ID } from "../../constants/telemetry";
import { QueryParam, getAdvertiserId } from "../../utils/permission.utils";
import { logWithTakt } from "../../utils/telemetry.utils";
import {
    AccountSwitcherContainer,
    AccountSwitcherWrapper,
} from "../common/styled.components";

import AccountDropdown, { SPOOFED_ACCOUNT_LABEL } from "./AccountDropdown";

export interface AccountSwitcherProps {
    width?: number;
}

export const AccountSwitcher: React.FunctionComponent<
    AccountSwitcherProps
> = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [selectedAccountId, setSelectedAccountId] = React.useState<
        string | null
    >(getAdvertiserId() ?? null);

    const urlParams = new URLSearchParams(location.search);
    const urlAccountId = urlParams.get(QueryParam.SALESFORCE_ID);

    const handleAccountSelect = (accountId: string) => {
        const previousAccountId = selectedAccountId;
        setSelectedAccountId(accountId);

        const searchParams = new URLSearchParams(location.search);
        // Remove marketplaceId from URL query parameters to prevent conflicts with
        // Salesforce-specific marketplace data. When marketplaceId is not present in URL,
        // it will be retrieved from the Salesforce context instead.
        searchParams.delete("marketplaceId");
        searchParams.set(QueryParam.SALESFORCE_ID, accountId);

        navigate(`${location.pathname}?${searchParams.toString()}`, {
            replace: true,
        });

        logWithTakt(TELEMETRY_ID.ACCOUNT_SWITCHER_SELECTION, {
            previousAccountId,
            newAccountId: accountId,
        });
        window.location.reload();
    };

    return (
        <AccountSwitcherContainer>
            <AccountSwitcherWrapper>
                <AccountDropdown
                    selectedAccountId={selectedAccountId}
                    onAccountSelect={handleAccountSelect}
                    showNoAccount={false}
                    overrideDisplayLabel={
                        urlAccountId ? SPOOFED_ACCOUNT_LABEL : undefined
                    }
                />
            </AccountSwitcherWrapper>
        </AccountSwitcherContainer>
    );
};
